<div class="row form-group">
  <div class="col-4 mt-3">
    <button #adicionar_ (click)="adicionar()" data-toggle="modal" data-target="#dialogExecutora"
      class="btn btn-sm btn-outline-primary" [disabled]="disabled()" title="CTRL + I">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th scope="col">Principal</th>
      <th scope="col">CNAE</th>
      <th scope="col" style="min-width: 120px;"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="!item.editavel " style="text-align: center; width: 80px">
        <i *ngIf="item.principal" class="fa fa-check text-success"></i>
        <i *ngIf="!item.principal" class="fa fa-close text-danger"></i>
      </td>
      <td *ngIf="!item.editavel" style="width: 90%"><b>{{item.cnae?.codigo}}</b> - {{item.cnae?.nome}}</td>
      <td *ngIf="item.editavel" style="width: 80px; text-align: center;">
        <div class="d-flex justify-content-center aling-items-center">
          <div class="checkboxcustom">
            <label>
              <input type="checkbox" [(ngModel)]="item.principal" id="principal">
              <span></span>
            </label>
          </div>
        </div>
      </td>
      <td *ngIf="item.editavel" style="width: 90%">
        <p-autoComplete #codigo_ id="cnae" [(ngModel)]="item.cnae" [forceSelection]="true" [autoHighlight]="true"
          [field]="cnaeAutoComplete.conversor" [suggestions]="cnaeAutoComplete.lista"
          (completeMethod)="cnaeAutoComplete.filtrar($event)" inputStyleClass="form-control form-control-sm"
          minLength="1" [style]="{ width: '100%' }" *ngIf="cnaeAutoComplete">
          <ng-template let-cnae pTemplate="item">
            {{cnae.codigo}} - {{cnae.nome}}
          </ng-template>
        </p-autoComplete>
      </td>
      <td class="text-right" style="min-width: 120px;">
        <button *ngIf="!item.editavel" (click)="editar(item)" [disabled]="disabled()" data-toggle="modal"
          data-target="#dialogExecutora" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item, idx)" [disabled]="disabled()"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>